import React, { Component } from 'react';
import { getItem } from 'utils/localStorage';
import { logPageView, initGA } from 'utils/analytics';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import { connect } from 'react-redux'; // to connect to redux store from containers redux.js or any other redux store
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component
import Header from 'components/DashBoardHeader';
import View from 'components/SettingsView';
import MiniFooter from 'components/MiniFooter';
import Session from 'components/Session';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import { getSAProfile, saveSAProfile, searchSchools } from 'components/GetUserDetails/actions';
import { changePassword, getPaymentHistory } from './actions';
import { selector } from './redux';
import styles from './Settings.scss';// to import local scss fle

class Settings extends Component {
  static propTypes = {
    attributes: PropTypes.shape(),
    location: PropTypes.shape().isRequired,
  };
  static defaultProps = {
    attributes: {},
  };
  constructor(props) {
    super(props);
    let currentIndex = 0;
    if (this.props.location.search !== '') {
      currentIndex = 1;
    }
    this.state = {
      value: '',
      tab: currentIndex,
      localZone: '',
    };
    this.tabListener = this.tabListener.bind(this);
  }
  componentWillMount() {
    const currentLocalZone = getItem('localZone');
    if (currentLocalZone === 'STUDENT') {
      this.setState({ localZone: currentLocalZone });
    } else {
      this.setState({ localZone: currentLocalZone });
    }
  }

  componentDidMount() {
    initGA();
        logPageView(this.props.match.path); // eslint-disable-line
  }

  componentWillReceiveProps() {
    const currentLocalZone = getItem('localZone');
    if (currentLocalZone === 'STUDENT') {
      this.setState({ localZone: currentLocalZone });
    } else {
      this.setState({ localZone: currentLocalZone });
    }
  }

  tabListener(tab) {
    this.setState({ tab });
  }

  render() {
    const renderCoachSettingsScreen = renderIf(this.props.attributes.get('zoneinfo') === 'COACH'
        || this.state.localZone === 'COACH');
    const renderAthleteSettingsScreen = renderIf(this.props.attributes.get('zoneinfo') === 'STUDENT'
        || this.props.attributes.get('zoneinfo') === 'PARENT' || this.state.localZone === 'STUDENT');
    return (

      <div className={cn('row', styles.cotnainer)}>
        {renderAthleteSettingsScreen(
          <div>
            <Header tabListener={this.tabListener} {...this.props} usedFor="settingsAthlete" />
            <View {...this.props} {...this.state} usedFor="athlete" />
            <div className={cn('col s12', styles.removePadding)}>
              <MiniFooter />
            </div>
          </div>,
          )}
        {renderCoachSettingsScreen(
          <div>
            <Header tabListener={this.tabListener} {...this.props} usedFor="settingsCoach" />
            <View {...this.props} {...this.state} usedFor="coach" />
            <div className={cn('col s12', styles.removePadding)}>
              <MiniFooter />
            </div>
          </div>,
          )}
      </div>
    );
  }
}

export default connect(selector,
  { getSAProfile,
    saveSAProfile,
    searchSchools,
    changePassword,
    getPaymentHistory,
  })(Session(Settings));



// WEBPACK FOOTER //
// ./src/containers/Settings/Settings.js